module.exports = __webpack_public_path__ + "fc1b49797f5c4256486076c3cda2e3ce.MP3";